// Empty Route:
export const EmptyRoute: string = '';
// Details Router:
export const DetailRoute: string = 'details';
// Nias auth route:
export const NiasAuthRoute: string = 'nias-auth';
// Nias act as model route:
export const NiasActAsModelRoute: string = 'nias-act-as-model';
// Nias logout route
export const NiasLogoutRoute: string = 'nias-logout';
// Not-found routes:
export const NotFoundAuthRoute: string = 'page-not-found';
export const NotFoundRoute = '**';
// EAuthorization-home route and all child routes:
export const EAuthorizationHomeRoute: string = 'eauthorisation-home';
// EAuthorization-managment route and and all child routes:
export const EAuthorizationManagmentRoute: string = 'eauthorisation-managment';
export const EAuthorizationManagmentViewRightsRoute: string = 'view-rights';
export const EAuthorizationManagmentViewReceivedRightsRoute: string = 'view-received-rights';
export const EAuthorizationManagmentViewGrantedRightsRoute: string = 'view-granted-rights';
export const EAuthorizationManagmentAssignRightsRoute: string = 'assign-rights';
// EAuthorization-authorized-person-overview route and and all child routes:
export const EAuthorizationAuthorisedPersonOverviewRoute: string = 'eauthorisation-authorised-person-overview';
// // EAuthorization-subject-overview route and and all child routes:
export const EAuthorizationSubjectOverviewRoute: string = 'eauthorisation-subject-overview';
// EAuthorization-eSerivices-mandates route and and all child routes:
export const EAuthorizationEServiceRoute: string = 'eauthorisation-eservices';
export const EAuthorizationEServicesGivenRightsRoute: string = 'given-rights-list';
export const EAuthorizationEServicesReceiveRightsRoute: string = 'receive-rights-list';
export const EAuthorizationEServicesCreateRightsRoute: string = 'create-rights';
export const EAuthorizationEServicesOverviewRightsRoute: string = 'eservices-overview-rights';
export const EAuthorizationEserviceMandatesRoute: string = 'eauthorisation-eservices-mandates';
export const EAuthorizationEservicesAssignMandates: string = 'assign-mandates';
export const EAuthorizationEservicesViewMandates: string = 'overview-mandates';
// EAuthorization-overview route and all child routes:
export const EAuthorizationOverviewRoute: string = 'eauthorisation-overview';
export const EAuthorizationOverviewFaqRoute: string = 'faq';
export const EAuthorizationOverviewSupportRoute: string = 'support';
export const EAuthorizationOverviewTermsOfUse: string = 'terms-of-uses';
export const EAuthorizationOverviewAccessibilityRoute: string = 'accessibility-statment';
export const EAuthorizationOverviewInstructionsRoute: string = 'user-instructions';
//Referent routes
export const ReferentHomeRoute: string = 'home';
export const ReferentContactRoute = 'contact';
export const ReferentSupervisionRoute: string = 'supervision';
export const ReferentSupervisionAddNativeRoute: string = 'add-native';
export const ReferentSupervisionSearchNativeRoute: string = 'search-native';
export const ReferentSupervisionViewRepresentationRoute: string = 'view-representation';
export const ReferentSupervisionEditRepresentationRoute: string = 'edit-representation';
export const ReferentSupervisionEditLegalRoute: string = 'edit-legal';
export const ReferentSupervisionSearchLegalRoute: string = 'search-legal';
export const ReferentSupervisionAttachmentViewRoute: string = 'attachement-view';

//Supervisor routes
export const SupervisorHomeRoute: string = 'supervisor-home';
export const SupervisorMenuRoute: string = 'menu-page-supervisor';
export const SupervisorAuthorisationsRoute: string = 'authorisations-page-supervisor';
export const SupervisorDocumentRoute: string = 'app-scanned-document';

export const ErrorRoute: string = 'error-page';
// EAuthorization-cosigners-list route:
export const EAuthorizationCosignersListRoute: string = 'eauthorization-cosigners-list';
